import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';

Vue.use(VueReCaptcha, {
    siteKey: "6Lf9PAErAAAAAIVOECxxgD7HOTxjpN2s1lClMSgD",
    loaderOptions: { useRecaptchaNet: true, autoHideBadge: true }
});